var _rect, _rect2, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.691406,
    width: 26.3077,
    height: 26.3077,
    rx: 4,
    fill: "#20C3FF",
    fillOpacity: 0.07
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.891406,
    y: 0.2,
    width: 25.9077,
    height: 25.9077,
    rx: 3.8,
    stroke: "#20C3FF",
    strokeOpacity: 0.07,
    strokeWidth: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8581 18.3488L5.85813 18.3485L5.86938 18.2755L5.86946 18.2749L5.87004 18.2711C5.94421 17.777 6.08023 16.8709 6.34335 15.9009C6.60648 14.9309 7.00062 13.8814 7.59868 13.1139M5.8581 18.3488L16.0609 7.0326C15.8604 6.84603 15.5711 6.79711 15.322 6.91047C15.0739 7.02332 14.9167 7.27247 14.9167 7.54608V7.54612L14.9174 9.74395C13.3257 9.76856 9.87864 10.1861 7.59868 13.1139M5.8581 18.3488C5.81162 18.6537 5.96852 18.9539 6.24551 19.0851C6.33776 19.1288 6.43504 19.15 6.53303 19.15C6.72885 19.15 6.91871 19.0647 7.05137 18.9081L7.05153 18.9079C7.89721 17.9067 9.36328 16.5636 11.5439 15.8433C12.6339 15.4836 13.7656 15.3219 14.9161 15.3626V17.9092C14.9161 18.1764 15.0674 18.4208 15.3057 18.537L15.3067 18.5374C15.546 18.6519 15.8289 18.6178 16.0342 18.4463L16.0343 18.4463L21.9007 13.5375L5.8581 18.3488ZM7.59868 13.1139L7.717 13.2061M7.59868 13.1139L7.717 13.2061M7.717 13.2061C10.0276 10.239 13.5656 9.89395 15.0674 9.89273L6.01772 18.2977L6.0182 18.2945C6.16656 17.3062 6.55896 14.6923 7.717 13.2061ZM16.2823 9.12426V10.4552C16.2823 10.6471 16.2045 10.8303 16.0664 10.9619C15.9288 11.0931 15.7459 11.1621 15.5528 11.1489L15.5527 11.1489C15.4865 11.1443 15.3366 11.1363 15.1236 11.1363H15.014C13.7209 11.1526 10.6197 11.4725 8.66811 13.978L16.2823 9.12426ZM16.2823 9.12426L20.4229 12.9733L16.2823 16.4379V14.7122C16.2823 14.3562 16.0171 14.0538 15.6642 14.0195L15.6641 14.0195C14.1142 13.8696 12.5853 14.0388 11.1214 14.5213L11.1214 14.5213C9.68512 14.9953 8.52348 15.7049 7.61365 16.4383C7.84272 15.5445 8.17811 14.6075 8.66808 13.978L16.2823 9.12426ZM21.9272 12.4868L16.0609 7.03269L21.8252 12.5967L21.9274 12.4869L21.9273 12.4868C21.9273 12.4868 21.9272 12.4868 21.9272 12.4868Z",
    fill: "#20C3FF",
    stroke: "#20C3FF",
    strokeWidth: 0.3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.79443a8e3a9126afb1bf38f87e185165.svg";
export { ForwardRef as ReactComponent };